module.exports = __webpack_public_path__ + "../front/img/368hylder+4skuffer.6023d197.svg";